// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { viewStyles } from "@guestsupply/Overrides/Widgets/ProductDetails/ProductDetailsView";
import CaretLeft from "@guestsupply/XDL/Icons/CaretLeft";
import { color, createLinkIconStyles, hideElementOnPrint, xScreen } from "@guestsupply/XDL/Utilities";
import { IconWrapper } from "@insite/mobius/Icon";
import { css } from "styled-components";

viewStyles.wrapper = {
    css: css`
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        @media print {
            display: flex !important;
        }
    `,
};
viewStyles.leftSection = {
    css: css`
        width: 543px;
        ${xScreen("lte", "md")} {
            width: 358px;
        }
        ${xScreen("lte", "sm")} {
            width: 100%;
        }
        @media print {
            width: 30%;
            margin-right: 10px;
        }
    `,
};
viewStyles.rightSection = {
    css: css`
        flex-grow: 1;
        width: calc(100% - 543px);
        padding-left: 22px;
        ${xScreen("lte", "md")} {
            width: calc(100% - 358px);
        }
        ${xScreen("lte", "sm")} {
            width: 100%;
            padding-left: 0;
        }
        @media print {
            page-break-inside: avoid;
            width: calc(70% - 10px);
        }
    `,
};
viewStyles.bottomSection = {
    css: css`
        width: 100%;
    `,
};
viewStyles.separator = {
    css: css`
        background-color: ${color("common.border")};
        width: 100%;
        height: 1px;
        margin: 20px 0;
    `,
};
viewStyles.productInfo = {
    css: css`
        display: flex;
    `,
};

viewStyles.stickyWrapper = {
    css: css`
        position: fixed;
        left: 0;
        background: ${color("common.white")};
        width: 100%;
        z-index: 1300;
        transition: all 300ms ease-out;
        opacity: 1;
        pointer-events: initial;
        min-height: 123px;
        height: auto;
        box-shadow: 0 1px 0 0 ${color("common.border")};

        &.stickyVisible {
            top: 0;
        }

        &.stickyHidden {
            top: -250px;
            &,
            & > * {
                max-height: 0;
                overflow: hidden;
            }
        }

        &.editingMode {
            position: unset;
        }

        ${xScreen("lte", "md")} {
            display: none;
        }

        ${hideElementOnPrint}
    `,
};

viewStyles.backLinkWrapper = {
    css: css`
        width: 100%;
        margin-bottom: 60px;
    `,
};

viewStyles.backLink = {
    ...createLinkIconStyles(CaretLeft, {
        color: "text.main",
        icon: {
            iconProps: {
                size: 9,
            },
            position: "left",
        },
        css: css`
            & > span {
                font-weight: normal;
                ${IconWrapper} {
                    margin-right: 5px;
                }
            }
        `,
    }),
};

viewStyles.badgesWrapper = {
    css: css`
        & > div {
            display: flex;
            flex-direction: column;
            gap: 8px;
            margin-top: 8px;

            &:empty {
                display: none;
            }
        }
    `,
};
